const getFiatBalance = (params) => {
    const { assetName, fiatBalances, walletAccount } = params;
    const walletAccountFiatBalances = fiatBalances.balances.byAssetSource[walletAccount];
    if (!walletAccountFiatBalances) {
        throw new Error(`Unknown wallet account ${walletAccount}`);
    }
    const assetFiatBalance = walletAccountFiatBalances[assetName];
    if (!assetFiatBalance) {
        throw new Error(`Unknown asset ${assetName}`);
    }
    return assetFiatBalance.balance;
};
export default getFiatBalance;
